// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var SuffixTree$SmartcutsMacros = require("../../bs-node-suffix-tree/src/SuffixTree.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var STEM__Interfaces$SmartcutsMacros = require("./STEM__Interfaces.bs.js");

function setIsFilteredBy(item, isFilteredBy) {
  item.isFilteredBy = isFilteredBy;
  
}

function getSuffixTreeNode(param) {
  return param.suffixTreeNode;
}

function getIsFilteredBy(param) {
  return param.isFilteredBy;
}

function isValid(param) {
  var isFilteredBy = param.isFilteredBy;
  return isFilteredBy === undefined;
}

function size(patterns) {
  return patterns.length;
}

function fromSuffixTree(suffixTree) {
  return Belt_Array.map(SuffixTree$SmartcutsMacros.allNodePaths(suffixTree), (function (nodePath) {
                var substring = SuffixTree$SmartcutsMacros.NodePath.collectSubstring(nodePath);
                var suffixTreeNode = SuffixTree$SmartcutsMacros.NodePath.bottom(nodePath);
                return [
                        substring,
                        {
                          suffixTreeNode: suffixTreeNode,
                          isFilteredBy: undefined
                        }
                      ];
              }));
}

function toArrayOfArrayOfPrintableTagPaths($$this, htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier, htmlTagPathByHtmlTagPathIdentifier) {
  return Belt_Array.map(Belt_Array.map($$this, (function (param) {
                    return STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.decodeToHtmlTagPathIdentifierSequence(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(param[0]), htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier);
                  })), (function (htpiSeq) {
                return Belt_Array.map(htpiSeq, (function (htpi) {
                              return Belt_Map.getExn(htmlTagPathByHtmlTagPathIdentifier, htpi).tags.join("/");
                            }));
              }));
}

function findBySubstring($$this, substring) {
  return List.assoc_opt(substring, $$Array.to_list($$this));
}

function forEachValidDataRecordPatterns(dataRecordPatterns, f) {
  return Belt_Array.forEach(dataRecordPatterns, (function (param) {
                var dataRecordPattern = param[1];
                if (isValid(dataRecordPattern)) {
                  return Curry._2(f, param[0], dataRecordPattern);
                }
                
              }));
}

function mapValidDataRecordPatterns(dataRecordPatterns, f) {
  return Belt_Array.keepMap(dataRecordPatterns, (function (param) {
                var dataRecordPattern = param[1];
                if (isValid(dataRecordPattern)) {
                  return Caml_option.some(Curry._2(f, param[0], dataRecordPattern));
                }
                
              }));
}

function reduceValidDataRecordPatterns(dataRecordPatterns, initResult, f) {
  return Belt_Array.reduce(dataRecordPatterns, initResult, (function (result, param) {
                var dataRecordPattern = param[1];
                if (isValid(dataRecordPattern)) {
                  return Curry._3(f, result, param[0], dataRecordPattern);
                } else {
                  return result;
                }
              }));
}

var DataRecordPatterns_DataRecordPattern = {
  getSuffixTreeNode: getSuffixTreeNode,
  getIsFilteredBy: getIsFilteredBy,
  setIsFilteredBy: setIsFilteredBy,
  isValid: isValid
};

var DataRecordPatterns = {
  DataRecordPattern: DataRecordPatterns_DataRecordPattern,
  size: size,
  fromSuffixTree: fromSuffixTree,
  toArrayOfArrayOfPrintableTagPaths: toArrayOfArrayOfPrintableTagPaths,
  findBySubstring: findBySubstring,
  forEachValidDataRecordPatterns: forEachValidDataRecordPatterns,
  mapValidDataRecordPatterns: mapValidDataRecordPatterns,
  reduceValidDataRecordPatterns: reduceValidDataRecordPatterns
};

function fromSignal(signal) {
  var encodedWebPageSequenceString = signal.encodedWebPageSequenceString;
  var suffixTree = SuffixTree$SmartcutsMacros.makeWithText(encodedWebPageSequenceString);
  var dataRecordPatterns = fromSuffixTree(suffixTree);
  var htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier = Curry._1(STEM__Interfaces$SmartcutsMacros.MapEncodedHtmlTagPathIdentifier.fromArray, Belt_Array.mapWithIndex(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.toArray(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(signal.encodedHtmlTagPathIdentifierString)), (function (index, encodedHtmlTagPathIdentifier) {
              return [
                      encodedHtmlTagPathIdentifier,
                      STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.fromInt(index)
                    ];
            })));
  return {
          suffixTree: suffixTree,
          encodedWebPageSequence: STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(encodedWebPageSequenceString),
          htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier,
          htmlTagPathIdentifierParentMap: signal.htmlTagPathIdentifierParentMap,
          dataRecordPatterns: dataRecordPatterns
        };
}

function assignFilter(filter, doeSuffixTreeNodeSatisfyFilter, $$this) {
  forEachValidDataRecordPatterns($$this.dataRecordPatterns, (function (substring, dataRecordPattern) {
          if (!Curry._3(doeSuffixTreeNodeSatisfyFilter, $$this, substring, Curry._1(DataRecordPatterns_DataRecordPattern.getSuffixTreeNode, dataRecordPattern))) {
            return Curry._2(DataRecordPatterns_DataRecordPattern.setIsFilteredBy, dataRecordPattern, filter);
          }
          
        }));
  return $$this;
}

function isAncestorNodeOf($$this, id1, id2) {
  var _id = id2;
  while(true) {
    var id = _id;
    var parentId = Belt_Map.get($$this.htmlTagPathIdentifierParentMap, id);
    if (parentId === undefined) {
      return false;
    }
    var parentId$1 = Caml_option.valFromOption(parentId);
    if (Caml_obj.caml_equal(parentId$1, id1)) {
      return true;
    }
    _id = parentId$1;
    continue ;
  };
}

function doeSuffixTreeNodeSatisfyFilter(param, nodeFrequencyEqualsOrGreaterThan, substringLengthEqualsOrGreaterThan, substring, suffixTreeNode) {
  if (substring.length >= substringLengthEqualsOrGreaterThan) {
    return SuffixTree$SmartcutsMacros.$$Node.frequency(param.suffixTree, suffixTreeNode) >= nodeFrequencyEqualsOrGreaterThan;
  } else {
    return false;
  }
}

function apply($$this, nodeFrequencyEqualsOrGreaterThan, substringLengthEqualsOrGreaterThan) {
  var param = {
    TAG: /* ByNodeFrequencyAndEdgeLength */0,
    _0: {
      nodeFrequencyEqualsOrGreaterThan: nodeFrequencyEqualsOrGreaterThan,
      substringLengthEqualsOrGreaterThan: substringLengthEqualsOrGreaterThan
    }
  };
  var param$1 = function (param$2) {
    return function (param$3, param$4) {
      return doeSuffixTreeNodeSatisfyFilter(param$2, nodeFrequencyEqualsOrGreaterThan, substringLengthEqualsOrGreaterThan, param$3, param$4);
    };
  };
  return assignFilter(param, param$1, $$this);
}

var ByNodeFrequencyAndEdgeLength = {
  doeSuffixTreeNodeSatisfyFilter: doeSuffixTreeNodeSatisfyFilter,
  apply: apply
};

function findLongestCommonSubstring(s1, s2) {
  var suffixTree = SuffixTree$SmartcutsMacros.makeWithText(s1 + s2);
  var possibleCommonSubstrings = Belt_Array.map(Belt_Array.keep(SuffixTree$SmartcutsMacros.allNodePaths(suffixTree), (function (nodePath) {
              return !SuffixTree$SmartcutsMacros.$$Node.isLeaf(SuffixTree$SmartcutsMacros.NodePath.bottom(nodePath));
            })), SuffixTree$SmartcutsMacros.NodePath.collectSubstring);
  return Belt_Array.reduce(possibleCommonSubstrings, undefined, (function (maybeLongestCommonSubstring, pattern) {
                if (maybeLongestCommonSubstring !== undefined && maybeLongestCommonSubstring.length >= pattern.length) {
                  return maybeLongestCommonSubstring;
                }
                if (s1.indexOf(pattern) > -1 && s2.indexOf(pattern) > -1) {
                  return pattern;
                } else {
                  return maybeLongestCommonSubstring;
                }
              }));
}

function calcRecordValidationRate(candidateSequence, dataRecordPattern) {
  var longestCommonSubstring = findLongestCommonSubstring(dataRecordPattern, candidateSequence);
  if (longestCommonSubstring !== undefined) {
    return longestCommonSubstring.length / dataRecordPattern.length;
  } else {
    return 0;
  }
}

function doeSuffixTreeNodeSatisfyFilter$1(param, recordValidationRateThreshold, patternValidationRate, substring, suffixTreeNode) {
  var suffixTree = param.suffixTree;
  var substringLength = substring.length;
  var childNodeAndSubSequences = Belt_Array.map(SuffixTree$SmartcutsMacros.$$Node.childNodes(suffixTree, suffixTreeNode), (function (childNode) {
          var subSequence = SuffixTree$SmartcutsMacros.traverse(suffixTree, "", (function (node, result) {
                  if (result.length >= substringLength) {
                    return result;
                  }
                  var arg = SuffixTree$SmartcutsMacros.$$Node.getText(node);
                  var text = (function (param) {
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                      })("Expect to get text from node");
                  return result + text;
                }), Caml_option.some(childNode), undefined);
          var func = function (param, param$1) {
            return param$1.slice(0, param);
          };
          return [
                  childNode,
                  Curry._2(func, substringLength, subSequence)
                ];
        }));
  var validChildNodes = Belt_Array.map(Belt_Array.keep(childNodeAndSubSequences, (function (param) {
              return calcRecordValidationRate(param[1], substring) >= recordValidationRateThreshold;
            })), (function (prim) {
          return prim[0];
        }));
  var sumOfAllChildNodesFrequency = Belt_Array.reduce(validChildNodes, 0, (function (acc, node) {
          return acc + SuffixTree$SmartcutsMacros.$$Node.frequency(suffixTree, node) | 0;
        }));
  return sumOfAllChildNodesFrequency / SuffixTree$SmartcutsMacros.$$Node.frequency(suffixTree, suffixTreeNode) >= patternValidationRate;
}

function apply$1($$this, recordValidationRate, patternValidationRate) {
  var param = {
    TAG: /* ByLongestCommonSubSequence */1,
    _0: {
      recordValidationRate: recordValidationRate,
      patternValidationRate: patternValidationRate
    }
  };
  var param$1 = function (param$2) {
    return function (param$3, param$4) {
      return doeSuffixTreeNodeSatisfyFilter$1(param$2, recordValidationRate, patternValidationRate, param$3, param$4);
    };
  };
  return assignFilter(param, param$1, $$this);
}

var ByLongestCommonSubSequence = {
  findLongestCommonSubstring: findLongestCommonSubstring,
  calcRecordValidationRate: calcRecordValidationRate,
  doeSuffixTreeNodeSatisfyFilter: doeSuffixTreeNodeSatisfyFilter$1,
  apply: apply$1
};

function maybeRotateHtmlTagPaths($$this, substring) {
  var htmlTagPathIdentifierSequence = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.decodeToHtmlTagPathIdentifierSequence(STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.fromText(substring), $$this.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier);
  var rootNodeIndex = Belt_Array.reduceWithIndex(htmlTagPathIdentifierSequence, 0, (function (rootNodeIndex, thisNode, index) {
          var rootNode = Caml_array.get(htmlTagPathIdentifierSequence, rootNodeIndex);
          if (isAncestorNodeOf($$this, thisNode, rootNode) || Caml_obj.caml_equal(thisNode, rootNode)) {
            return index;
          } else {
            return rootNodeIndex;
          }
        }));
  if (rootNodeIndex === 0) {
    return /* Keep */0;
  }
  var htmlTagPathIdentifier = Caml_array.get(htmlTagPathIdentifierSequence, rootNodeIndex);
  var s0 = Belt_Array.slice(htmlTagPathIdentifierSequence, 0, rootNodeIndex);
  var arg = Belt_Array.sliceToEnd(htmlTagPathIdentifierSequence, rootNodeIndex + 1 | 0);
  var len = (function (param) {
        return ArrayUtils$SmartcutsMacros.shortcutWithIndex(param, arg);
      })(function (htmlTagPathIdentifier$p, index) {
        if (STEM__Interfaces$SmartcutsMacros.HtmlTagPathIdentifier.compare(htmlTagPathIdentifier, htmlTagPathIdentifier$p) === 0) {
          return index;
        }
        
      });
  var htmlTagPathIdentifierSequenceList;
  if (len !== undefined) {
    var s1 = Belt_Array.slice(htmlTagPathIdentifierSequence, rootNodeIndex, len);
    htmlTagPathIdentifierSequenceList = {
      hd: s1,
      tl: {
        hd: Belt_Array.concat(s1, s0),
        tl: /* [] */0
      }
    };
  } else {
    htmlTagPathIdentifierSequenceList = {
      hd: Belt_Array.sliceToEnd(htmlTagPathIdentifierSequence, rootNodeIndex),
      tl: /* [] */0
    };
  }
  return /* ReplaceWith */{
          _0: htmlTagPathIdentifierSequenceList
        };
}

function apply$2($$this, substringLengthEqualsOrGreaterThan, param) {
  var doesSequenceSatifiesLengthFilter = function (htmlTagPathIdentifierSequence) {
    if (substringLengthEqualsOrGreaterThan !== undefined) {
      return htmlTagPathIdentifierSequence.length >= substringLengthEqualsOrGreaterThan;
    } else {
      return true;
    }
  };
  var dataRecordPatterns = reduceValidDataRecordPatterns($$this.dataRecordPatterns, $$this.dataRecordPatterns, (function (dataRecordPatterns, substring, dataRecordPattern) {
          var htmlTagPathIdentifierSequenceList = maybeRotateHtmlTagPaths($$this, substring);
          if (htmlTagPathIdentifierSequenceList) {
            return Belt_List.reduce(htmlTagPathIdentifierSequenceList._0, dataRecordPatterns, (function (dataRecordPatterns, htmlTagPathIdentifierSequence) {
                          var match = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.encodeFromHtmlTagPathIdentifierSequence(htmlTagPathIdentifierSequence);
                          var substring = STEM__Interfaces$SmartcutsMacros.EncodedHtmlTagPathIdentifierSequence.makeText(match[0]);
                          Curry._2(DataRecordPatterns_DataRecordPattern.setIsFilteredBy, dataRecordPattern, /* ByTreeStructure */0);
                          var dataRecordPattern$1 = List.assoc_opt(substring, $$Array.to_list($$this.dataRecordPatterns));
                          if (dataRecordPattern$1 === undefined) {
                            return dataRecordPatterns;
                          }
                          var dataRecordPattern$2 = Caml_option.valFromOption(dataRecordPattern$1);
                          if (!doesSequenceSatifiesLengthFilter(htmlTagPathIdentifierSequence)) {
                            return dataRecordPatterns;
                          }
                          var _filter = Curry._1(DataRecordPatterns_DataRecordPattern.getIsFilteredBy, dataRecordPattern$2);
                          if (_filter !== undefined) {
                            Curry._2(DataRecordPatterns_DataRecordPattern.setIsFilteredBy, dataRecordPattern$2, undefined);
                            return dataRecordPatterns;
                          } else {
                            return dataRecordPatterns;
                          }
                        }));
          } else {
            return dataRecordPatterns;
          }
        }));
  return {
          suffixTree: $$this.suffixTree,
          encodedWebPageSequence: $$this.encodedWebPageSequence,
          htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier: $$this.htmlTagPathIdentifierByEncodedHtmlTagPathIdentifier,
          htmlTagPathIdentifierParentMap: $$this.htmlTagPathIdentifierParentMap,
          dataRecordPatterns: dataRecordPatterns
        };
}

var ByTreeStructure = {
  maybeRotateHtmlTagPaths: maybeRotateHtmlTagPaths,
  apply: apply$2
};

function doeSuffixTreeNodeSatisfyFilter$2($$this, substring, param) {
  return reduceValidDataRecordPatterns($$this.dataRecordPatterns, true, (function (previousResult, repeatedSubstring, param) {
                if (previousResult) {
                  return !substring.slice(repeatedSubstring.length).startsWith(repeatedSubstring);
                } else {
                  return false;
                }
              }));
}

function apply$3($$this) {
  return assignFilter(/* ByRepetition */1, doeSuffixTreeNodeSatisfyFilter$2, $$this);
}

var ByRepetition = {
  doeSuffixTreeNodeSatisfyFilter: doeSuffixTreeNodeSatisfyFilter$2,
  apply: apply$3
};

var Filters = {
  ByNodeFrequencyAndEdgeLength: ByNodeFrequencyAndEdgeLength,
  ByLongestCommonSubSequence: ByLongestCommonSubSequence,
  ByTreeStructure: ByTreeStructure,
  ByRepetition: ByRepetition
};

function applyFilters($$this, filters) {
  return Belt_Array.reduce(filters, $$this, (function ($$this, filter) {
                if (typeof filter === "number") {
                  if (filter !== /* ByTreeStructure */0) {
                    return apply$3($$this);
                  }
                  var substringLengthEqualsOrGreaterThan = ArrayUtils$SmartcutsMacros.shortcut((function (filter) {
                          if (typeof filter === "number" || filter.TAG !== /* ByNodeFrequencyAndEdgeLength */0) {
                            return ;
                          } else {
                            return filter._0.substringLengthEqualsOrGreaterThan;
                          }
                        }), filters);
                  return apply$2($$this, substringLengthEqualsOrGreaterThan, undefined);
                } else {
                  if (filter.TAG === /* ByNodeFrequencyAndEdgeLength */0) {
                    var match = filter._0;
                    return apply($$this, match.nodeFrequencyEqualsOrGreaterThan, match.substringLengthEqualsOrGreaterThan);
                  }
                  var match$1 = filter._0;
                  return apply$1($$this, match$1.recordValidationRate, match$1.patternValidationRate);
                }
              }));
}

function output($$this) {
  var dataRecordPatternListBySubstring = reduceValidDataRecordPatterns($$this.dataRecordPatterns, undefined, (function (dataRecordPatternListBySubstring, substring, dataRecordPattern) {
          var dataRecordPatternList = Belt_MapString.get(dataRecordPatternListBySubstring, substring);
          if (dataRecordPatternList !== undefined) {
            return Belt_MapString.set(dataRecordPatternListBySubstring, substring, Belt_List.add(dataRecordPatternList, dataRecordPattern));
          } else {
            return Belt_MapString.set(dataRecordPatternListBySubstring, substring, {
                        hd: dataRecordPattern,
                        tl: /* [] */0
                      });
          }
        }));
  return {
          uniqueEncodedHtmlTagPathIdentifierStrings: Belt_MapString.keysToArray(dataRecordPatternListBySubstring)
        };
}

exports.DataRecordPatterns = DataRecordPatterns;
exports.fromSignal = fromSignal;
exports.isAncestorNodeOf = isAncestorNodeOf;
exports.Filters = Filters;
exports.applyFilters = applyFilters;
exports.output = output;
/* ArrayUtils-SmartcutsMacros Not a pure module */
